export const dailyActions = {
  CHANGE_INDEX: "CHANGE_INDEX",
};
